import React from 'react';
import { Button } from '@/components/ui/button';
import { Edit, Trash2 } from 'lucide-react';
import { EventSchedule } from '@/types';

interface ScheduleItemProps {
  item: EventSchedule;
  onEdit?: (id: string) => void;
  onDelete: (id: string) => void;
}

export const ScheduleItem: React.FC<ScheduleItemProps> = ({
  item,
  onEdit,
  onDelete
}) => {
  return (
    <div 
      className="flex items-center space-x-4 p-3 border rounded-lg hover:bg-gray-50 group"
    >
      <div className="flex-shrink-0 w-16">
        <span className="text-sm font-mono font-semibold text-blue-600">
          {item.hora}
        </span>
      </div>
      <div className="flex-1">
        <span className="text-sm text-gray-900">{item.actividad}</span>
      </div>
      <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
        <div className="flex space-x-1">
          {onEdit && (
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => onEdit(item.id)}
            >
              <Edit className="w-3 h-3" />
            </Button>
          )}
          <Button 
            variant="destructive_outline" 
            size="sm"
            onClick={() => onDelete(item.id)}
          >
            <Trash2 className="w-3 h-3" />
          </Button>
        </div>
      </div>
    </div>
  );
}; 